let ref;

ref = {
    states:[
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming',
        'Guam',
        'Puerto Rico',
        'Virgin Islands'
    ],
    professions: [
        'Petroleum Engineers',
        'Elevator Installers and Repairers',
        'Astronomers',
        'Phisycists',
        'Family and General Practitioners',
        'Internists, General',
        'Architectural and Engineering Managers',
        'Air Traffic Controllers',
        'Commercial Pilots',
        'Airline Pilots, Copilots, and Flight Engineers',
        'Captains, Mates, and Pilots of Water Vessel',
        'Surgical Technologists',
        'Radiation Therapists',
        'Interpreters and Translators',
        'Maintenance and Repair Workers, General',
        'Fundraisers',
        'Technical Writers',
        'Physical Therapist Aides',
        'Biomedical Engineers',
        'Pharmacy Technicians',
        'Phlebotomists',
        'Environmental Engineering Technicians',
        'Magnetic Resonance Imaging Technologists',
        'Massage Therapists',
        'Environmental Engineers',
        'Dietitians and Nutritionists',
        'Logisticians',
        'Management Analysts',
        'Social Workers, All Others',
        'Substance Abuse, Behavioral Disorder, and Mental Health Counselors',
        'Chiropractors',
        'Emergency Medical Technicians and Paramedics',
        'Financial Analysts',
        'Child, Family, and School Social Workers',
        'Genetic Counselors',
        'High School Teachers',
        'Marriage and Family Therapists',
        'Biochemists and Biophysicist',
        'Licensed Practical and Licensed Vocational Nurses',
        'Medical Secretaries',
        'Loan Officers',
        'Sales Managers',
        'Industrial-Organizational Psychologists',
        'Network and Computer Systems Administrators',
        'Human Resources Specialists',
        'Medical Assistants',
        'Police and Sheriff Patrol Officers',
        'Veterinarians',
        'Educational, Guidance, School, and Vocational Counselors', 
        'Hairdressers, Hairstylists, and Cosmetologists', 
        'Cost Estimators',
        'Market Research Analysts and Marketing Specialists',
        'Plumbers, Pipefitters, and Steamfitters',
        'Computer Network Architects',
        'Wind Turbine Service Technicians',
        'Home Health Aides',
        'Pharmacists',
        'Social and Community Service Managers',
        'Psychiatrists',
        'Personal Care Aides',
        'Web Developers',
        'Substance Abuse, Behavioral Disorder, and Mental Health Counselors',
        'Optometrists',
        'Database Administrators',
        'Orthotists and Prosthetists',
        'Political Scientists',
        'Clinical, Counseling, and School Psychologists',
        'Personal Financial Advisors',
        'Construction Managers',
        'Lawyers',
        'Mechanical Engineers',
        'Information Security Analysts',
        'Psychologists, All Other',
        'Landscaping and Groundskeeping Workers',
        'Business Operations Specialists, All Other',
        'Civil Engineers',
        'Diagnostic Medical Sonographers',
        'Operations Research Analysts',
        'Actuaries',
        'Physical Therapist Assistants',
        'Marketing Managers',
        'Dental Hygienists',
        'Medical and Health Services Managers',
        'Computer and Information Systems Managers',
        'Computer Systems Analysts',
        'Respiratory Therapists',
        'Financial Managers',
        'Accountants and Auditors',
        'Speech-Language Pathologists',
        'Podiatrists',
        'Clinical Laboratory Technologists and Technicians',
        'Physical Therapists',
        'Registered Nurses',
        'Cartographers and Photogrammetrists',
        'Mathematicians',
        'Nurse Midwives',
        'Surgeons',
        'Anesthesiologists',
        'Nurse Anesthetists',
        'Software Developers, Applications',
        'Software Developers, Systems Software',
        'Statisticians',
        'Physician Assistants',
        'Dentists, General',
        'Orthodontists',
        'Nurse Practitioners',
        'Pediatricians, General',
        'Obstetricians and Gynecologists',
        'Oral and Maxillofacial Surgeons',
        'Physicians and Surgeons, All Other',
        'Prosthodontists',
        'Occupational Therapists'
    ]
}

export default { ref };